import MsgCollectorV2 from './src/main';

/* istanbul ignore next */
MsgCollectorV2.install = function(Vue) {
  Vue.component(MsgCollectorV2.name, MsgCollectorV2);
};

export default MsgCollectorV2;
